import { Injectable } from '@angular/core';
import { WebApisService } from 'app/services/web-apis.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { GuapMakerCollection } from 'app/interfaces/guap-maker';
import { SocketService } from 'app/services/socket.service';
import { AuthenticationService } from 'app/auth/service';
import { takeUntil } from 'rxjs/operators';
import { FavoriteWallet } from 'app/interfaces/favourite-wallets';
@Injectable({
  providedIn: 'root'
})
export class NftService {

  public impactInfo: string = '"Influencers Score" demonstrates the distribution of volumes coming from influencers (followers greater than 10k) and "regular accounts" (followers less than 10k). Influencers, especially those with a large number of followers, will have material impact to the collection when they are posting tweets associated with the collection. A collection with 5% of the Twitter volumes from influencers is a tipping point, and indicates an increased chance of good performance. The higher the influencer involvement, the better the NFT performance.';
  public hypeInfo: string = '"Hype Score" is calculated based on posts and engagement volumes from Twitter accounts which are associated with the underlying NFT collection. We look at 7-day and 30-day Twitter activities with equal weights to quantify the increase / decrease in volumes and derive the hype score based on them, which range 0-100. Unchanged volumes will receive a score of 50; the higher the percentage change on volume, the higher the score will be. A high momentum score indicates increased probability of good performance of the NFT collection.';
  public momentumInfo: string = '"Momentum Score" is calculated based on the price and volume data from NFT transactions. According to our research, there are significant momentum patterns during NFT trading that can indicate if the prices will continue to rise or fall down. Depending on the time interval, momentum score is calculated using price and volume movements. Momentum score ranges from 0 to 100, the higher the score the stronger the momentum. A score of 50 means neutral level; a score below 50 indicates decrease of momentum; a score above 50 indicates increased momentum.';
  public backBtnClass = 'btn btn-sm btn-outline-primary';
  public nextBtnClass = 'btn btn-sm btn-primary btn-next';
  public selectedCollectionInfo = new BehaviorSubject<GuapMakerCollection>(null);
  public shareCollection = this.selectedCollectionInfo.asObservable();
  public selectedWalletInfo = new BehaviorSubject<string>(null);
  public shareWallet = this.selectedWalletInfo.asObservable();
  private _unsubscribeAll: Subject<any> = new Subject();

  public activeRoom: string = '';

  constructor(
    private socket: SocketService,
    private webApi: WebApisService) { }

  initSocket(){
    this.socket.on("connect", ()=>{
    });

    this.socket.on("close", ()=>{
    });

    this.socket.on("error", ()=>{
      console.log("socket error");
    });
  }

  getSocketTicker(){
    return this.socket.fromEvent('block-price');
  }

  getSocketTransaction(){
    return this.socket.fromEvent('nft-transactions');
  }

  getSocketNFTTransaction(socketname){
    return this.socket.fromEvent(socketname);
  }

  subscribeSocketNFTTransaction(){
    this.socket.emit('subscribe', 'nft-events');
  }

  unsubscribeSocketNFTTransaction(){
    this.socket.emit('unsubscribe', 'nft-events');
  }

  getSocketNFTMint(socketname){
    return this.socket.fromEvent(socketname);
  }

  subscribeSocketNFTMint(){
    this.socket.emit('subscribe', 'nft-mints');
  }

  unsubscribeSocketNFTMint(){
    this.socket.emit('unsubscribe', 'nft-mints');
  }

  subcribeSocketTransaction(userId: string, collectionSlug: string){
    return this.socket.emit('get-nft-transaction', userId, collectionSlug, (room) => {
      this.activeRoom = room;
    });
  }

  unsubscribeSocketTransaction(){
    this.socket.emit('unsubscribe', this.activeRoom);
  }

  subcribeSocket(){
    this.socket.emit('subscribe', 'block-price');
  }

  unsubcribeSocket(){
    this.socket.emit('unsubscribe', 'block-price');   
  }

  setCollection(collection: GuapMakerCollection){
    this.selectedCollectionInfo.next(collection);
  }

  setWallet(walletAddress: string){
    this.selectedWalletInfo.next(walletAddress);
  }

  public getSummeryCollection(contractID: string){
    return this.webApi.get<any>(`/nft/collection/${contractID}`)
  }

  public getNfts(contractAddress: string, collectionSlug: string, cursor?: string){
    let url = `/nft/collection/assets?collection_slug=${collectionSlug}&asset_contract_address=${contractAddress}`;
    if(cursor !== '') { url+= `&cursor=${cursor}`};
    return this.webApi.get<any>(url);
  }

  public getTransactionHistory(contractID: string, slug: string){
    return this.webApi.get<any>(`/nft/collection/history?asset_contract_address=${contractID}&collection_slug=${slug}`);
  }

  public getTransaction(contractID: string, slug: string, type: string, cursor?: string){
    let url = `/nft/collection/realtimeTransactions?asset_contract_address=${contractID}&collection_slug=${slug}&event_type=${type}`;
    if(cursor !== '') { url+= `&cursor=${cursor}`};
    return this.webApi.get<any>(url);
  }

  public searchProject(searchTerm: string){
    return this.webApi.get<any>(`/nft/collection/bySearch?filterKey=${searchTerm}`);
  }

  public getPremintTwitterInsight(projectType: string, currentPage: number, limit: number, searchTerm: string){
    let offset = limit * (currentPage - 1);
    if(searchTerm){
      return this.webApi.get<any>(`/nft/collection/getPremintTwitterInsight?projectType=${projectType}&searchKey=${searchTerm}&offset=${offset}&limit=${limit}`);
    } else {
      return this.webApi.get<any>(`/nft/collection/getPremintTwitterInsight?projectType=${projectType}&offset=${offset}&limit=${limit}`);
    }
  }

  public getPostmintTwitterInsight(contractAddress: string){
    return this.webApi.get<any>(`/nft/collection/getPostmintTwitterInsight/${contractAddress}`);
  }

  public addToWatchList(data){
    return this.webApi.post<any>(`/nft/watchlists`, data);
  }

  public getWatchlist(){
    return this.webApi.get<any>(`/nft/watchlists`);
  }

  public deleteWatchlist(id){
    return this.webApi.delete<any>(`/nft/watchlists/${id}`, null);
  }

  public createNotify(data){
    return this.webApi.post<any>(`/nft/notifications`, data);
  }

  public getAllNotifications(){
    return this.webApi.get<any>(`/nft/notifications`);
  }

  public deleteNotifications(id){
    return this.webApi.delete<any>(`/nft/notifications/${id}`, null);
  }

  public getOurProjects(){
    return this.webApi.get<any>(`/nft/promotedProjects`);
  }

  public getCollectionByOpenSea(duration: string, type: string){
    return this.webApi.get<any>(`/nft/collection/filter?duration=${duration}&type=${type}`);
  }

  public getCollectionTimeline(duration: string, interval: string, contractAddress: string){
    return this.webApi.get<any>(`/nft/collection/timeline?duration=${duration}&interval=${interval}&contractAddress=${contractAddress}`);
  }

  public getTopWallets(duration: string, type: string){
    return this.webApi.get<any>(`/nft/wallets?duration=${duration}&type=${type}`);
  }

  public getWalletActivity(type: string, cursor: string){
    let wallet = this.selectedWalletInfo.getValue();
    let url = `/nft/wallets/${wallet}/activity?type=${type}`;
    if(type == 'null'){
      if(cursor == ''){
        url = `/nft/wallets/${wallet}/activity`;
      } else {
        url = `/nft/wallets/${wallet}/activity?cursor=${cursor}`;
      }
    }
    if(cursor != ''){
      url += `&cursor=${cursor}`;
    }
    return this.webApi.get<any>(url);
  }

  public getWalletPortfolio(){
    return this.webApi.get<any>(`/nft/wallets/${this.selectedWalletInfo.getValue()}/portfolio`);
  }

  public getWalletPerformance(){
    return this.webApi.get<any>(`/nft/wallets/${this.selectedWalletInfo.getValue()}/performance`);
  }

  public getFavouritesWallet(){
    return this.webApi.get<any>(`/nft/wallets/favourites`);
  }

  public addFavouritesWallet(walletAddress: string){
    return this.webApi.post<any>(`/nft/wallets/favourites`, { address: walletAddress});
  }

  public deleteFavouritesWallet(walletAddress: string){
    return this.webApi.delete<any>(`/nft/wallets/favourites/${walletAddress}`, null);
  }

  public getCollectionOwners(){
    return this.webApi.get<any>(`/nft/collection/owners?contractAddress=${this.selectedCollectionInfo.getValue().contractAddress}`);
  }

  public getWhaleWallets(){
    return this.webApi.get<any>(`/nft/wallets/whale`);
  }
}
